import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import "../../assets/css/Auth.css";
import { Helmet } from "react-helmet";

const VerifyOtp = () => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Get email from query params (from ForgotPassword page)
  const email = new URLSearchParams(location.search).get("email");

  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    if (!otp.trim()) {
      toast.error("Please enter the OTP.");
      return;
    }

    setLoading(true);
    const formData = new URLSearchParams();
    formData.append("email", email);
    formData.append("otp", otp);

    try {
      const response = await fetch("https://api.biznetusa.com/api/verify-otp", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData.toString(),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success("OTP verified successfully!");
        setTimeout(() => {
          navigate(`/ResetPassword?email=${encodeURIComponent(email)}&token=${data.token}`);
        }, 2000);
      } else {
        throw new Error(data.message || "Invalid OTP, please try again.");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Verify OTP</title>
        <meta
          name="description"
          content="Enter the OTP sent to your email to verify your account."
        />
        <meta
          name="keywords"
          content="verify otp, email verification, password reset"
        />
      </Helmet>

      <main className="background_color_fixed">
        <div className="d-flex align-items-center justify-content-center min-vh-100">
          <div
            className="card body_color shadow-lg p-4"
            style={{ maxWidth: "26rem", width: "100%" }}
          >
            <h5 className="text-center mb-4">Verify OTP</h5>
            <p className="text-center text-muted mb-4">
              Enter the OTP sent to your email: <b>{email}</b>
            </p>
            <form onSubmit={handleVerifyOtp}>
              <div className="mb-3">
                <label className="form-label" htmlFor="otp">
                  OTP
                </label>
                <input
                  type="text"
                  id="otp"
                  placeholder="Enter OTP"
                  className="form-control text-center"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  maxLength="6"
                  required
                />
              </div>
              <button
                type="submit"
                className="btn w-100"
                disabled={loading}
              >
                {loading ? "Verifying..." : "Verify OTP"}
              </button>
            </form>
          </div>
        </div>
      </main>
      <ToastContainer />
    </>
  );
};

export default VerifyOtp;
